export default __webpack_public_path__ + "static/media/exclusive_deals.bb2582c8.png";